(function (global) {
  'use strict';
  function id(value) { return String(value || '').split('/').pop(); }
  function isInStock(variant, quantity) {
    var needed = quantity == null ? 1 : quantity;
    return Boolean(variant && variant.availableForSale === true && variant.currentlyNotInStock !== true &&
      typeof variant.quantityAvailable === 'number' && Number.isFinite(variant.quantityAvailable) &&
      Number.isFinite(needed) && needed > 0 && variant.quantityAvailable >= needed);
  }
  function stockLabel(variant, quantity) {
    if (!variant || typeof variant.quantityAvailable !== 'number' || !Number.isFinite(variant.quantityAvailable)) return '';
    if (variant.quantityAvailable <= 0 || variant.currentlyNotInStock === true) return 'Out of stock';
    if (!variant.availableForSale) return 'Unavailable';
    return isInStock(variant, quantity) ? '' : 'Insufficient stock';
  }
  function collectionState(data) {
    var empty = Boolean(data.loaded && !data.error && !data.hasMore && data.productCount === 0);
    return { empty: empty, blocking: empty && (data.minimumQuantity == null ? 1 : data.minimumQuantity) > 0 };
  }
  function sizeAvailability(variants, selectedOptions) {
    var sizes = new Map();
    (variants || []).forEach(function (variant) {
      var options = variant.selectedOptions || [];
      var size = options.find(function (option) { return /^size$/i.test(option.name); });
      if (!size || (selectedOptions || []).some(function (selected) {
        return !/^size$/i.test(selected.name) && !options.some(function (option) { return option.name === selected.name && option.value === selected.value; });
      })) return;
      if (!sizes.has(size.value)) sizes.set(size.value, []);
      sizes.get(size.value).push(variant);
    });
    return Array.from(sizes, function (entry) {
      var available = entry[1].some(function (variant) { return isInStock(variant, 1); });
      var soldOut = entry[1].every(function (variant) { return stockLabel(variant, 1) === 'Out of stock'; });
      return { value: entry[0], inStock: available, label: available ? '' : soldOut ? 'Out of stock' : 'Unavailable' };
    });
  }
  function productAvailability(variants) {
    if (!variants || !variants.length) return 'unknown';
    if (variants.some(function (variant) { return isInStock(variant, 1); })) return 'in-stock';
    if (variants.some(function (variant) { return !variant || typeof variant.quantityAvailable !== 'number' || !Number.isFinite(variant.quantityAvailable); })) return 'unknown';
    return variants.every(function (variant) { return stockLabel(variant, 1) === 'Out of stock'; }) ? 'out-of-stock' : 'unavailable';
  }
  function soldOutDisplayProducts(products, nativeIds) {
    var present = new Set((nativeIds || []).map(id));
    return (products || []).filter(function (product) { return !present.has(id(product.id)) && productAvailability(product.variants) === 'out-of-stock'; });
  }
  function matchesDisplaySource(product, kind) {
    if (kind === 'caps') return product.productType === 'Everyday Cap';
    if (kind === 'slides') return (product.tags || []).includes('bundled_slide');
    if (kind === 'henning') return product.title === 'Henning Mule' && !(product.tags || []).includes('FinalSale');
    return false;
  }
  function quantities(items) {
    var result = new Map();
    (items || []).forEach(function (item) {
      var key = id(item.variantId);
      result.set(key, (result.get(key) || 0) + Number(item.quantity || 1));
    });
    return result;
  }
  function unavailableItems(items, variants, existing) {
    var wanted = quantities(items);
    var stocks = new Map((variants || []).filter(Boolean).map(function (variant) { return [id(variant.id), variant]; }));
    var result = [];
    wanted.forEach(function (quantity, variantId) {
      if (!isInStock(stocks.get(variantId), quantity + (existing && existing.get(variantId) || 0))) {
        var original = items.find(function (item) { return id(item.variantId) === variantId; });
        result.push({ variantId: variantId, title: original && original.title || 'A bundle item', quantity: quantity });
      }
    });
    return result;
  }
  function cartQuantities(cart) {
    return quantities((cart.lines || []).flatMap(function (line) { return line.variants || []; }));
  }
  function unavailableCartItems(cart) {
    var all = (cart.lines || []).flatMap(function (line) { return line.variants || []; });
    var totals = cartQuantities(cart);
    var bundleItems = (cart.lines || []).filter(function (line) { return line.bundle; })
      .flatMap(function (line) { return line.variants || []; });
    var seen = new Set();
    return bundleItems.filter(function (item) {
      var key = id(item.variantId);
      if (seen.has(key)) return false;
      seen.add(key);
      var row = all.find(function (entry) { return id(entry.variantId) === key && entry.stock; });
      return !isInStock(row && row.stock, totals.get(key));
    });
  }
  function unavailableBundleIncrease(cart, lineNumber) {
    var line = cart.lines && cart.lines[lineNumber - 1];
    if (!line || !line.bundle || !Number.isInteger(line.quantity) || line.quantity < 1) throw new Error('Bundle cart line unavailable');
    var adjusted = Object.assign({}, line, { quantity: line.quantity + 1, variants: line.variants.map(function (item) {
      return Object.assign({}, item, { quantity: item.quantity / line.quantity * (line.quantity + 1) });
    }) });
    return unavailableCartItems({ lines: cart.lines.map(function (entry, index) { return index === lineNumber - 1 ? adjusted : entry; }) });
  }
  var api = { isInStock: isInStock, unavailableItems: unavailableItems, cartQuantities: cartQuantities, unavailableCartItems: unavailableCartItems, unavailableBundleIncrease: unavailableBundleIncrease, stockLabel: stockLabel, collectionState: collectionState, sizeAvailability: sizeAvailability, productAvailability: productAvailability, soldOutDisplayProducts: soldOutDisplayProducts, matchesDisplaySource: matchesDisplaySource, createSoldOutCard: createSoldOutCard };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global || !global.document) return;
  var document = global.document;
  var policy = document.querySelector('[data-message-bundle-stock-policy]');
  if (!policy || JSON.parse(policy.textContent).enabled !== true) return;
  var root;
  var config;
  var stock = new Map();
  var inFlight = new Set();
  var sizeProducts = new Map();
  var sizeRequests = new Set();
  // Match the automatic family rules of these bundle sources, without their
  // inventory rule. Only confirmed sold-out results become display-only cards.
  var displaySources = {
    '661976449333': { kind: 'caps', query: 'product_type:"Everyday Cap"' },
    '662301704501': { kind: 'slides', query: 'tag:bundled_slide' },
    '662409412917': { kind: 'henning', query: 'title:"Henning Mule" -tag:FinalSale' },
  };
  var displayProducts = new Map();
  var displayRequests = new Set();
  var scheduled = false;
  var adding = false;
  var addApproval = null;
  var addFailure = null;
  var checkoutApproval = null;
  var checkingCheckout = false;
  var checkingQuantity = false;
  var quantityApproval = null;
  var rootPath = global.Shopify && global.Shopify.routes && global.Shopify.routes.root || '/';

  function requestJson(url, options) {
    var controller = new AbortController();
    var timeout = global.setTimeout(function () { controller.abort(); }, 10000);
    return global.fetch(url, Object.assign({ cache: 'no-store', signal: controller.signal }, options)).then(function (response) {
      if (!response.ok) throw new Error('Stock check unavailable');
      return response.json();
    }).finally(function () { global.clearTimeout(timeout); });
  }
  function readConfig() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data.bundle && data.storefrontApiConfig) return data;
      } catch (_) {}
    }
    return null;
  }
  function loadVariants(items) {
    var ids = Array.from(new Set(items.map(function (item) { return 'gid://shopify/ProductVariant/' + id(item.variantId); })));
    if (!ids.length) return Promise.resolve([]);
    var connection = config && config.storefrontApiConfig;
    if (!connection) return Promise.reject(new Error('Stock connection unavailable'));
    var query = 'query BundleStock($ids: [ID!]!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {' +
      ' nodes(ids: $ids) { ... on ProductVariant { id title availableForSale quantityAvailable currentlyNotInStock product { id } } } }';
    return requestJson('https://' + connection.shopDomain + '/api/' + connection.apiVersion + '/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': connection.storefrontToken },
      body: JSON.stringify({ query: query, variables: { ids: ids, country: config.localization.countryCode, language: config.localization.languageCode.toUpperCase().replace('-', '_') } }),
    }).then(function (response) {
      if (response.errors || !response.data || !Array.isArray(response.data.nodes)) {
        if (response.errors) global.console.warn('Bundle stock lookup: ' + response.errors.map(function (error) { return error.message; }).join('; '));
        throw new Error('Stock data unavailable');
      }
      ids.forEach(function (variantId, index) { stock.set(id(variantId), { variant: response.data.nodes[index] || null, time: Date.now() }); });
      return response.data.nodes;
    });
  }
  function selectedItems() {
    if (!root || !config) return [];
    return Array.from(root.querySelectorAll('bundly-slot[data-variant-id]')).map(function (slot) {
      var index = Number(slot.getAttribute('data-component-index'));
      var component = config.bundle.components[index];
      var title = slot.querySelector('.bundly__slot_product_title') || slot.querySelector('.bundly__slot_title');
      return { variantId: slot.getAttribute('data-variant-id'), title: title && title.textContent.trim().split('\n')[0] || 'A bundle item',
        quantity: component && !component.id.includes('/Collection/') ? Number(component.quantity || 1) : 1 };
    });
  }
  function loadSizeVariants(productId, after, collected) {
    var connection = config && config.storefrontApiConfig;
    if (!connection) return Promise.reject(new Error('Stock connection unavailable'));
    var query = 'query BundleSizes($id: ID!, $after: String, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {' +
      ' node(id: $id) { ... on Product { variants(first: 100, after: $after) { nodes { id availableForSale quantityAvailable currentlyNotInStock selectedOptions { name value } } pageInfo { hasNextPage endCursor } } } } }';
    return requestJson('https://' + connection.shopDomain + '/api/' + connection.apiVersion + '/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': connection.storefrontToken },
      body: JSON.stringify({ query: query, variables: { id: 'gid://shopify/Product/' + productId, after: after || null,
        country: config.localization.countryCode, language: config.localization.languageCode.toUpperCase().replace('-', '_') } }),
    }).then(function (response) {
      var variants = response.data && response.data.node && response.data.node.variants;
      if (response.errors || !variants || !Array.isArray(variants.nodes) || !variants.pageInfo) throw new Error('Size stock data unavailable');
      var all = (collected || []).concat(variants.nodes.filter(Boolean));
      if (variants.pageInfo.hasNextPage) {
        if (!variants.pageInfo.endCursor || variants.pageInfo.endCursor === after) throw new Error('Size stock data incomplete');
        return loadSizeVariants(productId, variants.pageInfo.endCursor, all);
      }
      return all;
    });
  }
  function renderSizeOptions(fieldset, rows) {
    var inputs = Array.from(fieldset.querySelectorAll('input[data-option-name="Size"]'));
    var doc = fieldset.ownerDocument;
    // Added choices never register an app radio/variant ID: only Bundly's own
    // stock-filtered radios can select merchandise.
    fieldset.querySelectorAll('.message-bundly-missing-size').forEach(function (node) {
      var value = node.getAttribute('data-size-value');
      if (inputs.some(function (input) { return input.value === value; }) || !rows.some(function (row) { return row.value === value; })) node.remove();
    });
    rows.forEach(function (row, index) {
      var input = inputs.find(function (node) { return node.value === row.value; });
      var holder;
      if (input) {
        holder = input.closest('.bundly__product_option_value');
        if (!holder) return;
        if (!row.inStock && !input.disabled) {
          input.setAttribute('data-message-size-disabled', ''); input.disabled = true;
        } else if (row.inStock && input.hasAttribute('data-message-size-disabled')) {
          input.removeAttribute('data-message-size-disabled'); input.disabled = false;
        }
        holder.toggleAttribute('data-message-size-unavailable', !row.inStock);
        var label = holder.querySelector('label');
        badge(label, null, row.label, 'message-bundly-size-stock', 'span');
      } else {
        holder = Array.from(fieldset.querySelectorAll('.message-bundly-missing-size')).find(function (node) { return node.getAttribute('data-size-value') === row.value; });
        if (!holder) {
          holder = doc.createElement('div'); holder.className = 'bundly__product_option_value bundly__product_option_value_pill message-bundly-missing-size';
          holder.setAttribute('data-size-value', row.value); holder.setAttribute('data-message-size-unavailable', '');
          var button = doc.createElement('button'); button.type = 'button'; button.disabled = true;
          var value = doc.createElement('span'); value.textContent = row.value; button.appendChild(value); holder.appendChild(button);
          var next = rows.slice(index + 1).map(function (later) { return inputs.find(function (node) { return node.value === later.value; }); }).find(Boolean);
          fieldset.insertBefore(holder, next ? next.closest('.bundly__product_option_value') : null);
        }
        var disabled = holder.querySelector('button');
        // Stocked but excluded from the collection remains ineligible until
        // Shopify/Bundly refresh membership; never make it a custom choice.
        var status = row.label || 'Unavailable';
        var name = row.value + ' — ' + status;
        if (disabled.getAttribute('aria-label') !== name) disabled.setAttribute('aria-label', name);
        badge(disabled, null, status, 'message-bundly-size-stock', 'span');
      }
    });
  }
  function renderSizeAvailability() {
    if (!config) return;
    root.querySelectorAll('.bundly__product_modal[open]').forEach(function (modal) {
      var productId = modal.getAttribute('data-product-id');
      var card = root.querySelector('[data-product-id="' + productId + '"][data-product-handle]');
      if (!card || !/(?:shaw|mullen|henning)/i.test(card.getAttribute('data-product-handle') || '')) return;
      var input = modal.querySelector('input[data-option-name="Size"]');
      var fieldset = input && input.closest('.bundly__product_option');
      if (!fieldset) return;
      var saved = productStock(productId);
      badge(fieldset, null, saved && saved.error ? 'Unable to load full size availability. Refresh to try again.' : '', 'message-bundly-size-error');
      if (!saved || !saved.variants || saved.error) return;
      var otherOptions = Array.from(modal.querySelectorAll('input[data-option-name]:checked')).map(function (node) {
        return { name: node.getAttribute('data-option-name'), value: node.value };
      });
      renderSizeOptions(fieldset, sizeAvailability(saved.variants, otherOptions));
    });
  }
  function productStock(productId) {
    var saved = sizeProducts.get(productId);
    if ((!saved || Date.now() - saved.time > 30000) && !sizeRequests.has(productId)) {
      sizeRequests.add(productId);
      loadSizeVariants(productId).then(function (variants) {
        var time = Date.now();
        sizeProducts.set(productId, { variants: variants, time: time });
        variants.forEach(function (variant) {
          stock.set(id(variant.id), { variant: Object.assign({}, variant, { product: { id: 'gid://shopify/Product/' + productId } }), time: time });
        });
      }).catch(function () { sizeProducts.set(productId, { error: true, time: Date.now() }); })
        .finally(function () { sizeRequests.delete(productId); schedule(); });
    }
    return saved;
  }
  function renderProductCards() {
    if (!config) return;
    root.querySelectorAll('bundly-collection-component-card[data-product-id]').forEach(function (card) {
      var saved = productStock(card.getAttribute('data-product-id'));
      var state = saved && saved.variants ? productAvailability(saved.variants) : saved && saved.error ? 'error' : 'checking';
      if (card.getAttribute('data-message-product-stock') !== state) card.setAttribute('data-message-product-stock', state);
      var blocked = state !== 'in-stock';
      var caption = state === 'out-of-stock' ? 'Out of stock' : state === 'checking' ? 'Checking availability…' : 'Unavailable';
      card.querySelectorAll('button').forEach(function (button) {
        var modal = button.closest('.bundly__product_modal');
        var action = button.classList.contains('bundly__choose_options_button') || button.classList.contains('bundly__add_to_bundle_button');
        if (button.classList.contains('bundly__component_count_badge') || (modal && !action)) return;
        if (blocked && !button.disabled) { button.setAttribute('data-message-product-disabled', ''); button.disabled = true; }
        else if (!blocked && button.hasAttribute('data-message-product-disabled')) { button.removeAttribute('data-message-product-disabled'); button.disabled = false; }
        if (!action) return;
        button.toggleAttribute('data-message-stock-action', blocked);
        badge(button, null, blocked ? caption : '', 'message-bundly-stock-action-label', 'span');
        if (blocked) {
          if (!button.hasAttribute('data-message-native-action-label')) button.setAttribute('data-message-native-action-label', button.getAttribute('aria-label') || '');
          var name = (button.getAttribute('data-message-native-action-label') || '').split(' — ')[0] + ' — ' + caption;
          if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label', name);
        } else if (button.hasAttribute('data-message-native-action-label')) {
          button.setAttribute('aria-label', button.getAttribute('data-message-native-action-label'));
          button.removeAttribute('data-message-native-action-label');
        }
      });
      var info = card.querySelector('.bundly__component_info');
      badge(info, info && info.querySelector(':scope > .bundly__choose_options_button, :scope > .bundly__add_to_bundle_button'),
        saved && saved.error ? 'We couldn’t check this item’s stock. Please refresh to try again.' : '', 'message-bundly-product-stock-error');
    });
  }
  function loadDisplayProducts(source, after, collected) {
    var connection = config.storefrontApiConfig;
    var field = (config.metafieldConfig || 'custom.current_color_name').split(',')[0].trim().replace(/^(?:card|dialog):/, '').split('.');
    var query = 'query BundleDisplayProducts($query: String!, $after: String, $namespace: String!, $key: String!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {' +
      ' products(first: 20, after: $after, query: $query) { nodes { id title handle productType tags featuredImage { url altText } color: metafield(namespace: $namespace, key: $key) { value }' +
      ' priceRange { minVariantPrice { amount currencyCode } maxVariantPrice { amount currencyCode } }' +
      ' variants(first: 100) { nodes { id availableForSale quantityAvailable currentlyNotInStock selectedOptions { name value } } pageInfo { hasNextPage } } } pageInfo { hasNextPage endCursor } } }';
    return requestJson('https://' + connection.shopDomain + '/api/' + connection.apiVersion + '/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': connection.storefrontToken },
      body: JSON.stringify({ query: query, variables: { query: source, after: after || null, namespace: field[0], key: field[1],
        country: config.localization.countryCode, language: config.localization.languageCode.toUpperCase().replace('-', '_') } }),
    }).then(function (response) {
      var products = response.data && response.data.products;
      if (response.errors || !products || !Array.isArray(products.nodes) || !products.pageInfo) throw new Error('Product display data unavailable');
      return Promise.all(products.nodes.map(function (product) {
        if (!product || !product.variants || !product.variants.pageInfo) throw new Error('Product stock data incomplete');
        var variants = product.variants.pageInfo.hasNextPage ? loadSizeVariants(id(product.id)) : Promise.resolve(product.variants.nodes);
        return variants.then(function (nodes) { return Object.assign({}, product, { variants: nodes }); });
      })).then(function (nodes) {
        var all = (collected || []).concat(nodes);
        if (products.pageInfo.hasNextPage) {
          if (!products.pageInfo.endCursor || products.pageInfo.endCursor === after) throw new Error('Product display data incomplete');
          return loadDisplayProducts(source, products.pageInfo.endCursor, all);
        }
        return all;
      });
    });
  }
  function createSoldOutCard(product, doc, localization) {
    var card = doc.createElement('article');
    card.className = 'bundly__component_grid_item message-bundly-soldout-card';
    card.setAttribute('data-product-id', id(product.id));
    var image = doc.createElement('div'); image.className = 'bundly__component_image';
    if (product.featuredImage) {
      var img = doc.createElement('img'); img.src = product.featuredImage.url; img.alt = product.featuredImage.altText || product.title; img.loading = 'lazy';
      image.appendChild(img);
    }
    var info = doc.createElement('div'); info.className = 'bundly__component_info';
    var title = doc.createElement('p'); title.className = 'bundly__component_title'; title.textContent = product.title; title.style.margin = '0'; info.appendChild(title);
    if (product.color && product.color.value) {
      var color = doc.createElement('div'); color.className = 'bundly__product_custom_data'; color.textContent = product.color.value; info.appendChild(color);
    }
    var sizes = sizeAvailability(product.variants);
    if (sizes.length === 1 && /^one size$/i.test(sizes[0].value)) {
      var size = doc.createElement('p'); size.className = 'message-bundly-card-size message-bundly-fixed-size'; size.textContent = 'Size: One size'; info.appendChild(size);
    }
    if (product.priceRange) {
      var amount = product.priceRange.minVariantPrice;
      var price = doc.createElement('div'); price.className = 'bundly__component_original_price';
      price.textContent = (product.priceRange.maxVariantPrice.amount !== amount.amount ? 'From ' : '') +
        new Intl.NumberFormat(localization.languageCode, { style: 'currency', currency: amount.currencyCode }).format(Number(amount.amount));
      info.appendChild(price);
    }
    var button = doc.createElement('button'); button.type = 'button'; button.disabled = true;
    button.className = 'bundly__choose_options_button'; button.textContent = 'Out of stock'; button.setAttribute('aria-label', product.title + ' — Out of stock');
    button.setAttribute('data-message-stock-action', '');
    info.appendChild(button); card.append(image, info); return card;
  }
  function renderSoldOutProducts() {
    if (!config) return;
    root.querySelectorAll('bundly-collection-component').forEach(function (component) {
      var index = component.getAttribute('data-component-index') || component.getAttribute('component-index');
      var definition = config.bundle.components[Number(index)];
      var sourceId = definition && id(definition.id);
      var source = displaySources[sourceId];
      var grid = component.querySelector('.bundly__component_grid');
      if (!source || !grid) return;
      var saved = displayProducts.get(sourceId);
      if ((!saved || Date.now() - saved.time > 30000) && !displayRequests.has(sourceId)) {
        displayRequests.add(sourceId);
        loadDisplayProducts(source.query).then(function (products) { displayProducts.set(sourceId, { products: products.filter(function (product) { return matchesDisplaySource(product, source.kind); }), time: Date.now() }); })
          .catch(function () { displayProducts.set(sourceId, { error: true, time: Date.now() }); })
          .finally(function () { displayRequests.delete(sourceId); schedule(); });
      }
      badge(component, null, saved && saved.error ? 'We couldn’t load the sold-out items. Please refresh to try again.' : '', 'message-bundly-product-stock-error');
      if (!saved || !saved.products || saved.error) return;
      var nativeIds = Array.from(grid.querySelectorAll('bundly-collection-component-card')).map(function (card) { return card.getAttribute('data-product-id'); });
      var products = soldOutDisplayProducts(saved.products, nativeIds);
      var existing = Array.from(grid.querySelectorAll('.message-bundly-soldout-card'));
      existing.forEach(function (card) { if (!products.some(function (product) { return id(product.id) === card.getAttribute('data-product-id'); })) card.remove(); });
      products.forEach(function (product) {
        if (!existing.some(function (card) { return card.getAttribute('data-product-id') === id(product.id); })) grid.appendChild(createSoldOutCard(product, document, config.localization));
      });
    });
  }
  function fingerprint(items) { return JSON.stringify(items.map(function (item) { return [id(item.variantId), Number(item.quantity || 1)]; }).sort()); }
  function messageFor(unavailable) {
    if (unavailable.length === 1) return unavailable[0].title + ' does not have enough stock. This bundle is currently unavailable.';
    return 'Some bundle items do not have enough stock. Please update your selections.';
  }
  function notice(parent, before, message) {
    var node = parent.querySelector(':scope > .message-bundly-stock-status');
    if (!message) { if (node) node.remove(); return; }
    if (!node) {
      node = document.createElement('p');
      node.className = 'message-bundly-stock-status';
      node.setAttribute('data-item', 'small-text');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      parent.insertBefore(node, before);
    }
    if (node.textContent !== message) node.textContent = message;
  }
  function badge(parent, before, label, className, tagName) {
    if (!parent) return;
    var node = parent.querySelector(':scope > .' + className);
    if (!label) { if (node) node.remove(); return; }
    if (!node) {
      node = document.createElement(tagName || 'p');
      node.className = className;
      parent.insertBefore(node, before);
    }
    if (node.textContent !== label) node.textContent = label;
  }
  function renderItemLabels(items) {
    root.querySelectorAll('bundly-slot[data-variant-id]').forEach(function (slot) {
      var item = items.find(function (entry) { return id(entry.variantId) === slot.getAttribute('data-variant-id'); });
      var saved = item && stock.get(id(item.variantId));
      var title = slot.querySelector('.bundly__slot_title');
      badge(title, title && title.querySelector('.bundly__slot_color, .bundly__slot_variant_title'),
        stockLabel(saved && saved.variant, item && item.quantity), 'message-bundly-item-stock');
    });
    root.querySelectorAll('bundly-product-component-card, bundly-collection-component-card').forEach(function (card) {
      var candidates = items.filter(function (item) {
        var saved = stock.get(id(item.variantId));
        var nativeId = card.getAttribute('data-selected-variant-id');
        return nativeId ? id(item.variantId) === nativeId : card.hasAttribute('data-message-selected') && saved && saved.variant &&
          saved.variant.product && id(saved.variant.product.id) === card.getAttribute('data-product-id');
      });
      var labels = candidates.map(function (item) { var saved = stock.get(id(item.variantId)); return stockLabel(saved && saved.variant, item.quantity); }).filter(Boolean);
      var info = card.querySelector('.bundly__component_info');
      badge(info, info && info.querySelector('.bundly__custom_data_metafields, .bundly__product_availability'), labels[0] || '', 'message-bundly-item-stock');
    });
  }
  function renderCollections() {
    var blocked = [];
    root.querySelectorAll('bundly-collection-component').forEach(function (component) {
      var index = component.getAttribute('data-component-index') || component.getAttribute('component-index');
      var definition = config && config.bundle.components[Number(index)];
      var minimum = definition && definition.quantity_type === 'maximum' ? 0 :
        definition && (definition.quantity_type === 'range' || definition.quantity_type === 'minimum') ? Number(definition.quantity_min || 0) :
          definition && definition.quantity != null ? Number(definition.quantity) : 1;
      var grid = component.querySelector('.bundly__component_grid');
      var error = component.querySelector('.bundly__component_variant--error');
      var cards = grid && Array.from(grid.querySelectorAll('bundly-collection-component-card')) || [];
      var known = cards.every(function (card) { return /^(in-stock|out-of-stock|unavailable)$/.test(card.getAttribute('data-message-product-stock')); });
      var state = grid || error ? collectionState({ loaded: Boolean(grid) && known, productCount: cards.filter(function (card) { return card.getAttribute('data-message-product-stock') === 'in-stock'; }).length,
        error: Boolean(error), hasMore: Boolean(component.querySelector('.bundly__component_pagination button')), minimumQuantity: minimum }) :
        { empty: component.hasAttribute('data-message-collection-empty'), blocking: component.hasAttribute('data-message-collection-empty') && minimum > 0 };
      component.toggleAttribute('data-message-collection-empty', state.empty);
      var header = component.querySelector('.bundly__component_header > div');
      badge(header, header && header.querySelector('.bundly__component_header_description'), state.empty ? 'Out of stock' : '', 'message-bundly-component-stock');
      var panel = component.querySelector('.message-bundly-empty-state');
      if (state.empty && grid) {
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'message-bundly-empty-state';
          panel.setAttribute('role', 'status');
          var heading = document.createElement('p'); heading.className = 'message-bundly-empty-title'; heading.textContent = 'No options in stock';
          var description = document.createElement('p'); description.className = 'message-bundly-empty-description';
          var link = document.createElement('a'); link.href = rootPath + 'collections/all'; link.textContent = 'Shop all';
          panel.append(heading, description, link); grid.insertBefore(panel, grid.firstChild);
        }
        var copy = state.blocking ? 'There are currently no in-stock options for this part of your bundle. Please check back later.' :
          'There are currently no in-stock options for this part of your bundle. You can continue without it.';
        var descriptionNode = panel.querySelector('.message-bundly-empty-description');
        if (descriptionNode.textContent !== copy) descriptionNode.textContent = copy;
      } else if (panel) panel.remove();
      root.querySelectorAll('bundly-slot[data-component-index="' + index + '"]:not([data-variant-id])').forEach(function (slot) {
        slot.toggleAttribute('data-message-collection-empty', state.empty);
        var title = slot.querySelector('.bundly__slot_title');
        badge(title, null, state.empty ? 'Out of stock' : '', 'message-bundly-component-stock');
      });
      if (state.blocking) blocked.push(index);
    });
    return blocked;
  }
  function paint(message, blocked, unavailable) {
    if (!root) return;
    var buy = root.querySelector('bundly-buy-buttons');
    if (!buy) return;
    notice(buy.parentElement, buy, message);
    var completion = buy.querySelector('.message-bundly-completion');
    if (completion) completion.hidden = Boolean(blocked && (unavailable || root.querySelector('bundly-details-heading[data-complete="true"]')));
    var button = buy.querySelector('.bundly__add_to_cart_button');
    if (!button) return;
    button.toggleAttribute('data-message-unavailable', Boolean(unavailable));
    var unavailableLabel = button.querySelector('.message-bundly-unavailable-label');
    if (unavailable && !unavailableLabel) {
      unavailableLabel = document.createElement('span');
      unavailableLabel.className = 'message-bundly-unavailable-label'; unavailableLabel.textContent = 'Bundle unavailable';
      button.appendChild(unavailableLabel);
    } else if (!unavailable && unavailableLabel) unavailableLabel.remove();
    if (blocked) {
      if (!button.hasAttribute('data-message-stock-blocked')) button.setAttribute('data-message-stock-blocked', '');
      if (!button.disabled) button.disabled = true;
    } else if (button.hasAttribute('data-message-stock-blocked')) {
      button.removeAttribute('data-message-stock-blocked');
      button.disabled = !root.querySelector('bundly-details-heading[data-complete="true"]') || adding;
    }
  }
  function refresh() {
    root = document.querySelector('.bundly__block.message-bundly-compact');
    if (!root) return;
    config = readConfig();
    renderProductCards();
    renderSoldOutProducts();
    renderSizeAvailability();
    var items = selectedItems();
    var empty = renderCollections().length > 0;
    renderItemLabels(items);
    var emptyMessage = 'This bundle is currently unavailable because a required selection has no in-stock options.';
    if (!items.length) { paint(empty ? emptyMessage : '', empty, empty); return; }
    if (addFailure && (addFailure.key !== fingerprint(items) || Date.now() - addFailure.time > 30000)) addFailure = null;
    if (addFailure) { paint(addFailure.message, true, addFailure.unavailable || empty); return; }
    var failed = items.some(function (item) { var saved = stock.get(id(item.variantId)); return saved && saved.error && Date.now() - saved.time <= 30000; });
    if (failed) { paint(empty ? emptyMessage : 'We couldn’t check bundle availability. Please refresh to try again.', true, empty); return; }
    var missing = items.filter(function (item) { var saved = stock.get(id(item.variantId)); return !saved || Date.now() - saved.time > 30000; });
    if (missing.length) {
      var pending = missing.filter(function (item) { return !inFlight.has(id(item.variantId)); });
      paint(empty ? emptyMessage : 'Checking bundle availability…', true, empty);
      if (pending.length) {
        pending.forEach(function (item) { inFlight.add(id(item.variantId)); });
        loadVariants(pending).catch(function () {
          pending.forEach(function (item) { stock.set(id(item.variantId), { error: true, time: Date.now() }); });
        }).finally(function () { pending.forEach(function (item) { inFlight.delete(id(item.variantId)); }); schedule(); });
      }
      return;
    }
    var unavailable = unavailableItems(items, Array.from(stock.values()).map(function (saved) { return saved.variant; }));
    paint(empty ? emptyMessage : unavailable.length ? messageFor(unavailable) : '', empty || unavailable.length > 0 || adding, empty || unavailable.length > 0);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    global.requestAnimationFrame(function () { scheduled = false; refresh(); });
  }
  // Cancelling the app's own event also covers modal navigation or keyboard
  // paths that bypass the card; required automatic products are unaffected.
  document.addEventListener('bundly:beforeAddVariant', function (event) {
    var detail = event.detail || {};
    // Initialization restores saved choices; the separate fresh purchase check
    // still blocks restored items that have since sold out.
    if (detail.sourceElement && detail.sourceElement.localName === 'bundly-init') return;
    var source = event.target && event.target.closest && event.target.closest('.message-bundly-compact');
    if (!source) return;
    var data = readConfig();
    var component = data && data.bundle.components[Number(detail.componentIndex)];
    if (!component || !component.id.includes('/Collection/')) return;
    var saved = stock.get(id(detail.variantId));
    if (!saved || !isInStock(saved.variant, 1)) { event.preventDefault(); schedule(); }
  }, true);
  document.addEventListener('bundly:beforeAddBundleToCart', function (event) {
    var detail = event.detail || {};
    if (!detail.bundleItems || !detail.sourceElement) return;
    var key = fingerprint(detail.bundleItems);
    if (addApproval && addApproval.key === key && Date.now() - addApproval.time < 3000) { addApproval = null; return; }
    event.preventDefault();
    if (adding) return;
    adding = true;
    root = detail.sourceElement.closest('.bundly__block');
    config = readConfig();
    paint('Checking bundle availability…', true);
    var selection = fingerprint(selectedItems());
    Promise.all([loadVariants(detail.bundleItems), requestJson(rootPath + 'cart?view=bundle-stock', { credentials: 'same-origin' })]).then(function (responses) {
      adding = false;
      var unavailable = unavailableItems(detail.bundleItems, responses[0], cartQuantities(responses[1]));
      if (unavailable.length) {
        addFailure = { key: selection, time: Date.now(), message: messageFor(unavailable), unavailable: true };
        paint(addFailure.message, true, true); return;
      }
      if (selection !== fingerprint(selectedItems())) { schedule(); return; }
      addApproval = { key: key, time: Date.now() };
      paint('', false);
      var button = detail.sourceElement.querySelector('.bundly__add_to_cart_button');
      if (button && button.isConnected && !button.disabled) button.click();
    }).catch(function () {
      adding = false;
      addFailure = { key: selection, time: Date.now(), message: 'We couldn’t check bundle availability. Please refresh to try again.' };
      paint(addFailure.message, true);
    });
  }, true);
  function checkout(event, button) {
    if (checkoutApproval && checkoutApproval.button === button && Date.now() - checkoutApproval.time < 3000 && !checkoutApproval[event.type]) {
      checkoutApproval[event.type] = true;
      return;
    }
    if (!document.querySelector('.message-bundle-components')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingCheckout) return;
    checkingCheckout = true;
    button.setAttribute('aria-busy', 'true');
    requestJson(rootPath + 'cart?view=bundle-stock', { credentials: 'same-origin' }).then(function (cart) {
      var unavailable = unavailableCartItems(cart);
      checkingCheckout = false;
      button.removeAttribute('aria-busy');
      if (unavailable.length) { notice(button.parentElement, button, messageFor(unavailable) + ' Update the quantity or remove the unavailable bundle to continue.'); return; }
      notice(button.parentElement, button, '');
      checkoutApproval = { button: button, time: Date.now() };
      if (button.isConnected && !button.disabled) button.click();
    }).catch(function () {
      checkingCheckout = false;
      button.removeAttribute('aria-busy');
      notice(button.parentElement, button, 'We couldn’t check bundle availability. Please try again.');
    });
  }
  function increaseQuantity(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    var button = event.target.closest && event.target.closest('.quantity-selector--plus');
    if (!button || !button.closest) return;
    var row = button.closest('.cart--item');
    if (!row || !row.querySelector('.message-bundle-components')) return;
    if (quantityApproval && quantityApproval.button === button && Date.now() - quantityApproval.time < 3000) { quantityApproval = null; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingQuantity) return;
    checkingQuantity = true;
    button.setAttribute('aria-busy', 'true');
    var current = row.querySelector('.quantity-selector--input').value;
    var parent = row.querySelector('.cart--item--title') || row;
    requestJson(rootPath + 'cart?view=bundle-stock', { credentials: 'same-origin' }).then(function (cart) {
      var lineNumber = Number(row.getAttribute('data-line-num'));
      if (!cart.lines[lineNumber - 1] || cart.lines[lineNumber - 1].quantity !== Number(current)) throw new Error('Cart update pending');
      var unavailable = unavailableBundleIncrease(cart, lineNumber);
      if (unavailable.length) {
        notice(parent, null, 'There isn’t enough stock to add another bundle. Please keep the current quantity or choose other items.');
        return;
      }
      if (!button.isConnected || row.querySelector('.quantity-selector--input').value !== current) return;
      notice(parent, null, '');
      quantityApproval = { button: button, time: Date.now() };
      button.click();
    }).catch(function () { notice(parent, null, 'We couldn’t check bundle availability. Please try again.'); })
      .finally(function () { checkingQuantity = false; button.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', increaseQuantity, true);
  document.addEventListener('keydown', increaseQuantity, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="checkout"]');
    if (button) checkout(event, button);
  }, true);
  document.addEventListener('submit', function (event) {
    var button = event.submitter;
    if (!button) button = event.target.querySelector && event.target.querySelector('button[name="checkout"]');
    if (button && button.name === 'checkout') checkout(event, button);
  }, true);
  ['bundly:afterLoadBundle', 'bundly:afterAddVariant', 'bundly:afterRemoveVariant', 'bundly:afterChangeVariantOption', 'bundly:afterUpdateBlock', 'DOMContentLoaded', 'shopify:section:load'].forEach(function (name) { document.addEventListener(name, schedule); });
  var host = document.querySelector('.bundly__information_app_block');
  if (host) {
    var observer = new MutationObserver(schedule);
    observer.observe(host, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-variant-id', 'data-complete', 'disabled', 'class', 'open'] });
  }
  global.setInterval(function () { if (document.visibilityState === 'visible') schedule(); }, 30000);
  document.addEventListener('visibilitychange', schedule);
  schedule();
})(typeof window === 'undefined' ? null : window);
